import { render, staticRenderFns } from "./apply_record.vue?vue&type=template&id=6ecaa569&"
import script from "./apply_record.vue?vue&type=script&lang=ts&"
export * from "./apply_record.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports